import ModalBase from './modal';
import { ReactComponent as CheckIcon } from '../../assets/images/icons/check_circle.svg';

export default function ModalSuccess(props) {
  return <ModalBase {...props} icon={<CheckIcon />} />;
}
